import { render, staticRenderFns } from "./SemesterManager.vue?vue&type=template&id=af315870&"
import script from "./SemesterManager.vue?vue&type=script&lang=js&"
export * from "./SemesterManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports